import React, { Component } from 'react';
import LocaleCountryCheckbox from '../../../components/shared/locale-country-checkbox';
import LocaleLanguageCheckbox from '../../../components/shared/locale-language-checkbox';
import SmsOptInEnabledCheckbox from '../../../components/shared/sms-opt-in-enabled-checkbox';
import PhoneNumberCountriesPanel from '../../../components/shared/phone-number-countries-panel';
import EmailOptInEnabledCheckbox from '../../../components/shared/email-opt-in-enabled-checkbox';
import OptInCopyPanel from '../../../components/shared/opt-in-copy-panel';
import LocaleDefaultValueDropdown from '../../../components/shared/locale-default-value-dropdown';
import GuestCheckoutEnabledCheckbox from '../../../components/shared/guest-checkout-enabled-checkbox';
import FirstNameEnabledCheckbox from '../../../components/shared/first-name-enabled-checkbox';
import LastNameEnabledCheckbox from '../../../components/shared/last-name-enabled-checkbox';
import PhoneNumberEnabledCheckbox from '../../../components/shared/phone-number-enabled-checkbox';


class RegistrationFeaturesCapsule extends Component {

    render() {

        return (
            <div className="row" style={{ marginTop: '1%' }}>
                <div className="col-12">
                    <span className="text-left">
                        <strong>Registration Features</strong>
                    </span>
                    <div style={{ marginLeft: '0.5rem' }}>
                        <LocaleCountryCheckbox onChange={this.props.onLocaleCountryChanged}
                            checked={this.props.localeCountryChecked} />
                        {this.props.localeCountryChecked && (
                            <LocaleDefaultValueDropdown
                                title="Default Country"
                                value={this.props.localeDefaultCountry}
                                menuItems={this.props.countries}
                                onUpdated={this.props.onLocaleDefaultCountryUpdated}
                            />
                        )}
                        <LocaleLanguageCheckbox onChange={this.props.onLocaleLanguageChanged}
                            checked={this.props.localeLanguageChecked} />
                        {this.props.localeLanguageChecked && (
                            <LocaleDefaultValueDropdown
                                title="Default Language"
                                value={this.props.localeDefaultLanguage}
                                menuItems={this.props.languages}
                                onUpdated={this.props.onLocaleDefaultLanguageUpdated}
                            />
                        )}
                        <FirstNameEnabledCheckbox onChange={this.props.onFirstNameEnabledChanged}
                            checked={this.props.firstNameEnabled} />
                        <LastNameEnabledCheckbox onChange={this.props.onLastNameEnabledChanged}
                            checked={this.props.lastNameEnabled} />
                        <PhoneNumberEnabledCheckbox onChange={this.props.onPhoneNumberEnabledChanged}
                            checked={this.props.phoneNumberEnabled} />
                        <PhoneNumberCountriesPanel
                            countries={this.props.phoneNumberCountries}
                            onAdd={this.props.onPhoneNumberCountryAdded}
                            onRemove={this.props.onPhoneNumberCountryRemoved}
                        />
                        <SmsOptInEnabledCheckbox onChange={this.props.onSmsOptInEnabledChanged}
                            checked={this.props.smsOptInEnabled} />
                        {this.props.smsOptInEnabled && (
                            <OptInCopyPanel
                                title="SMS Opt-In Copy"
                                copy={this.props.smsOptInCopy}
                                onCopyUpdated={this.props.onSmsOptInCopyUpdated}
                            />
                        )}
                        <EmailOptInEnabledCheckbox onChange={this.props.onEmailOptInEnabledChanged}
                            checked={this.props.emailOptInEnabled} />
                        {this.props.emailOptInEnabled && (
                            <OptInCopyPanel
                                title="Email Opt-In Copy"
                                copy={this.props.emailOptInCopy}
                                onCopyUpdated={this.props.onEmailOptInCopyUpdated}
                            />
                        )}
                        <GuestCheckoutEnabledCheckbox onChange={this.props.onGuestCheckoutEnabledChanged}
                            checked={this.props.guestCheckoutEnabled} />
                    </div>
                </div>
            </div>
        );
    }
}

export default RegistrationFeaturesCapsule;
